import { useEffect } from 'react';
import { registerReferralCapture } from '@lib/rewardful';

/**
 * FFH-1991: registers the affiliate-referral capture on Rewardful's `ready`
 * queue (replacing a fixed 1s timer that raced the consent-gated, async
 * rw.js and silently missed captures). The callback fires whenever the SDK
 * actually loads, then persists the referral to sessionStorage and the
 * 30-day first-party cookie read at checkout.
 */
export const useStoreRewardfulReferral = () => {
  useEffect(() => {
    try {
      registerReferralCapture();
    } catch {
      // Attribution must never break the page.
    }
  }, []);
};
